import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=6d2443e6&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=6d2443e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2443e6",
  null
  
)

export default component.exports